import { useEffect } from 'react';
import { K3Extensions, useApp } from '@k3/core';
import { DeepRequired } from '../types/DeepRequired';

export const OrderDialog: DeepRequired<K3Extensions>['app']['orderDialog']['root'] =
  (Wrapped) => {
    return (props) => {
      const app = useApp();

      useEffect(() => {
        if (
          props.saveResult &&
          props.saveResult.code &&
          props.action.id === app.settings.defaultAction
        ) {
          const req = {
            action: 'cart',
            data: {
              code: props.saveResult.code,
            },
          };
          console.log(
            'K3 is sending req to parent via window.parent.postMessage(). req:',
            req
          );
          window.parent.postMessage(req, '*');
          props.handleClose();
        }
      }, [props.saveResult]);
      return <Wrapped {...props} />;
    };
  };
